import {merge} from 'mojito/utils';

import {
    generateEventCardBadge,
    generateEventCardBadgeRow,
} from '#core/application/modules/tiles/event-card-badge/index.js';
import {
    generateAvantgardeEventCardInplayScoreAccent,
    generateAvantgardeOddsButton,
} from '#core/application/modules/cards-and-promotions/avantgarde-cards/avantgarde-event-card-common.js';

function generateOutrightEventCardAvantgardeDetails(PALETTE, CARD_DETAILS) {
    return {
        showBackgroundSportImage: !PALETTE.PARENT.CARD_WATERMARK_ICON_HIDDEN,
        showCustomBackgroundImage: true,
        eventCardBase: {
            container: {
                style: {
                    borderColor: PALETTE.OUTRIGHT_ACCENT_BORDER,
                },
            },
        },
        badgeRow: generateEventCardBadgeRow(PALETTE.OUTRIGHT_EVENT_CARD_BADGE),
        categoryBadge: generateEventCardBadge(PALETTE.OUTRIGHT_EVENT_CARD_BADGE),
        sportCountryIcons: {
            sportIcon: {
                icon: {
                    style: {
                        fill: CARD_DETAILS.SPORT_ICON_COLOR,
                        minWidth: 12,
                    },
                },
            },
        },
        leagueRow: {
            style: {
                padding: 8,
            },
        },
        leagueName: {
            container: {
                position: 'relative',
            },
            style: CARD_DETAILS.EVENT_NAME_TEXT,
        },
        scoreboard: generateAvantgardeEventCardInplayScoreAccent(CARD_DETAILS),
        marketNameLabel: {
            style: CARD_DETAILS.MARKET_NAME_TEXT,
        },
        showAllLabel: {
            style: CARD_DETAILS.SHOW_ALL_LINK.SECONDARY_LINK_TEXT,
        },
        showAllIcon: {
            style: {
                fill: CARD_DETAILS.SHOW_ALL_LINK.SECONDARY_LINK_ICON_COLOR,
            },
        },
        selectionButton: generateAvantgardeOddsButton(CARD_DETAILS.ODDS_BUTTON),
    };
}

export function avantgardeOutrightCardsFactory(PALETTE, COLOR_MODE) {
    return {
        OutrightEventCardAvantgarde: merge(
            generateOutrightEventCardAvantgardeDetails(PALETTE, PALETTE.CARD_EVENT_DETAILS_LIGHT),
            {
                mode: COLOR_MODE,
                eventCardDetailsDark: generateOutrightEventCardAvantgardeDetails(
                    PALETTE,
                    PALETTE.CARD_EVENT_DETAILS_DARK
                ),
            }
        ),
    };
}
